import { render, staticRenderFns } from "./MyGallinas.vue?vue&type=template&id=cb7f059c&"
import script from "./MyGallinas.vue?vue&type=script&lang=js&"
export * from "./MyGallinas.vue?vue&type=script&lang=js&"
import style0 from "./MyGallinas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports